import { ApolloClient, NormalizedCacheObject, ObservableQuery } from '@apollo/client'
import { VaultsQuery } from "../queries/vault";

export const fetchVaults = (
  client: ApolloClient<NormalizedCacheObject>,
): ObservableQuery => {
  return client.watchQuery({
    query: VaultsQuery,
    fetchPolicy: 'cache-and-network',
    pollInterval: 6*10000, // 60 seconds
  })
}